export const fetchSiteMetrics = async () => {
    // Simulated API call (can be replaced with Axios or fetch later)
    await new Promise(resolve => setTimeout(resolve, 500));
  
    return {
      siteSessions: 1324,
      aiInteractions: 504,
      leadsCaptured: 12,
      topPage: "Projects"
    };
  };
  